import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FeatureSelectionSummary } from '../../core/map-selection-context.service';

/** One presentation for the map-owned selections in Composer and Workspace. */
@Component({
  selector: 'app-selection-summary',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './selection-summary.component.html',
  styleUrls: ['./selection-summary.component.css'],
})
export class SelectionSummaryComponent {
  @Input() selections: readonly FeatureSelectionSummary[] = [];
  @Input() activeFeatureKey: string | null = null;
  @Output() featureSelected = new EventEmitter<string>();
  @Output() clearAll = new EventEmitter<void>();
}
